
const getters = {
  getRate: state => currency => state.currencies[currency],
  hasErrors: state => state.hasErrors
}

export default getters